/*
*###############################################################################
*Module Name                   : ScaleDataPrintContent.js                      #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Friday, February 02nd 2024, 9:18:43 Am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useRef, useState } from "react"

import {
  Col,
  Row,
  Button,
  Table,
  Alert
} from "reactstrap"

const TransactionExcelUploadContent = ({

  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,
  displayAlertMessage,
  SetLoadingAlert,
  SetLoadingAlerttitle


}) => {
  const [file, setFile] = useState(null);
  const inputref = useRef(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {

    if (!file) {
      return
    }


    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('startColumnName', "TotQty");
      formData.append('endColumnName', "BalQty");

      let requestOptions = {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`
        },
        body: formData,
        redirect: 'follow'
      };

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Uploading Excel File")

      const response = await fetch(`${ApiURL}txn/dynamicExcelTxn`, requestOptions);
      const result = await response.json();
      if (response.ok) {
        if (result.success) {
          displayAlertMessage("success", result.message)
        } else {
          displayAlertMessage("danger", result.message)
        }
      } else {
        console.error('Error uploading file:', response.statusText);
        displayAlertMessage("danger", result.message)
      }
    } catch (error) {
      console.error('Error:', error.message);
    } finally {
      SetLoadingAlert(false)
    }

    if (inputref.current) {
      inputref.current.value = "";
    }
    setFile(null)

  };

  return (
    <React.Fragment>
      <Row>
        {show ? (
          <Alert color={AlertColor} role="alert">
            {AlertMsg}
            <br />
            <small>{ErrorMsg}</small>
          </Alert>
        ) : null}
      </Row >
      <Row className="mt-3">
        <h6>Please upload the excel file to import the transactions</h6>
      </Row>
      <Row className="mt-3">
        <div>
          <input type="file" ref={inputref} onChange={handleFileChange} />
          <Button color="primary" size="sm" onClick={handleUpload}>Upload</Button>
        </div>
      </Row>
      <Row>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </Row>
    </React.Fragment >
  )
}
export default TransactionExcelUploadContent




